import React from "react";
import { usePohrebka2 } from "../../context/Pohrebka2Context";

const cardStyle = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: 20,
  boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
};

const titleStyle = {
  fontSize: 30,
  fontWeight: 900,
  color: "#111827",
  marginBottom: 8,
};

const subStyle = {
  color: "#6b7280",
  fontSize: 15,
  marginBottom: 20,
};

const sectionStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 14,
  padding: 16,
  marginBottom: 16,
  background: "#fafafa",
};

const sectionTitleStyle = {
  fontSize: 18,
  fontWeight: 800,
  color: "#111827",
  marginBottom: 12,
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 14,
};

const fieldWrapStyle = {
  display: "grid",
  gap: 6,
};

const labelStyle = {
  fontSize: 13,
  fontWeight: 800,
  color: "#374151",
};

const inputStyle = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: 10,
  padding: "10px 12px",
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
  background: "#fff",
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 100,
  resize: "vertical",
};

const badgeRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
  marginTop: 14,
};

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  borderRadius: 999,
  padding: "8px 12px",
  fontWeight: 800,
  background: "#eff6ff",
  color: "#1d4ed8",
  border: "1px solid #93c5fd",
};

function round2(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

function formatMoney(n) {
  return `${round2(n).toFixed(2).replace(".", ",")} Kč`;
}

export default function Pohrebka2PlatbaForm() {
  const { order, setOrder } = usePohrebka2();

  const platba = order?.platba || {};
  const sluzby = Array.isArray(order?.sluzby) ? order.sluzby : [];

  const zaloha = round2(platba?.zalohovaPlatba);

  const rawUhrazeno = platba?.uhrazenoCelkem;
  const uhrazeno = round2(
    rawUhrazeno === "" || rawUhrazeno === null || rawUhrazeno === undefined
      ? zaloha
      : rawUhrazeno
  );

  const setPlatbaField = (field, value) => {
    setOrder((prev) => ({
      ...(prev || {}),
      platba: {
        ...(prev?.platba || {}),
        [field]: value,
      },
    }));
  };

  return (
    <div style={cardStyle}>
      <div style={titleStyle}>Platba / finance</div>
      <div style={subStyle}>
        Evidence zálohy, úhrady a poznámek k finančnímu vypořádání zakázky.
      </div>

      <div style={sectionStyle}>
        <div style={sectionTitleStyle}>Platební údaje</div>

        <div style={gridStyle}>
          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Záloha</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={platba.zalohovaPlatba ?? ""}
              onChange={(e) => setPlatbaField("zalohovaPlatba", e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Uhrazeno celkem</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={platba.uhrazenoCelkem ?? ""}
              onChange={(e) => setPlatbaField("uhrazenoCelkem", e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Způsob úhrady</label>
            <select
              value={platba.zpusobUhrady ?? ""}
              onChange={(e) => setPlatbaField("zpusobUhrady", e.target.value)}
              style={inputStyle}
            >
              <option value="">-- vyber --</option>
              <option value="hotovost">Hotovost</option>
              <option value="karta">Karta</option>
              <option value="prevod">Převod</option>
              <option value="faktura">Faktura</option>
              <option value="jinak">Jinak</option>
            </select>
          </div>

          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Datum úhrady</label>
            <input
              type="date"
              value={platba.datumUhrady ?? ""}
              onChange={(e) => setPlatbaField("datumUhrady", e.target.value)}
              style={inputStyle}
            />
          </div>
        </div>

        <div style={{ ...fieldWrapStyle, marginTop: 14 }}>
          <label style={labelStyle}>Poznámka k platbě</label>
          <textarea
            value={platba.poznamkaPlatba ?? ""}
            onChange={(e) => setPlatbaField("poznamkaPlatba", e.target.value)}
            style={textareaStyle}
          />
        </div>

        <div style={badgeRowStyle}>
          <span style={badgeStyle}>Záloha: {formatMoney(zaloha)}</span>
          <span style={badgeStyle}>Uhrazeno: {formatMoney(uhrazeno)}</span>
          <span style={badgeStyle}>Počet služeb v zakázce: {sluzby.length}</span>
        </div>
      </div>
    </div>
  );
}
